import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

export interface SetupGuideProgressBarProps {
  progress: number;
}

/*
 * Style.
 */

const StyledProgressContainerDiv = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${(p) => p.theme.greys.shade30};
  border-radius: 10px;
  margin-bottom: 16px;
`;

interface StyledProgressDivProps {
  $progress: number;
}
const StyledProgressDiv = styled.div<StyledProgressDivProps>`
  width: ${(p) => (p.$progress === 0 ? '5%' : `${p.$progress}%`)};
  height: 100%;
  background-color: ${(p) => p.theme.palette.green.shade40};
  border-radius: 10px;
  transition: width 1s;
`;

/*
 * Component.
 */

export const SetupGuideProgressBar: FC<SetupGuideProgressBarProps> = ({progress}) => (
  <StyledProgressContainerDiv>
    <StyledProgressDiv $progress={progress} />
  </StyledProgressContainerDiv>
);
